import { customerReturnUrl } from '../utils/return-url';
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { FlowContextStore } from '../stores';

function toPositiveInt(value: unknown): number | null {
  if (typeof value === 'number' && Number.isFinite(value) && value > 0) {
    return value;
  }
  if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) {
    const parsed = Number(value);
    return parsed > 0 ? parsed : null;
  }
  return null;
}

function parsePromotionIdFromReturnUrl(returnUrl: string | null): number | null {
  if (!returnUrl) return null;
  const match = returnUrl.match(/\/(?:promotion|events)\/(\d+)/);
  if (!match || !match[1]) return null;
  return toPositiveInt(match[1]);
}

export const flowContextGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const flowContextStore = inject(FlowContextStore);
  const flowContextOptional = route.data?.['flowContextOptional'] === true;

  const routePromotionId = toPositiveInt(route.params['id']);
  const queryDeviceId = toPositiveInt(route.queryParams['deviceId']);
  const returnUrl = typeof route.queryParams['returnUrl'] === 'string' ? route.queryParams['returnUrl'] : null;
  const autoGenerateCoupon = route.queryParams['autoGenerateCoupon'] === 'true';

  const returnUrlPromotionId = parsePromotionIdFromReturnUrl(returnUrl);
  const storeState = flowContextStore.state();

  const promotionId = routePromotionId ?? returnUrlPromotionId ?? storeState.promotionId;
  const deviceId = queryDeviceId ?? storeState.deviceId;
  const effectiveReturnUrl = customerReturnUrl(returnUrl ?? storeState.returnUrl ?? state.url);
  const originRoute = storeState.originRoute ?? state.url;

  if (promotionId && deviceId) {
    flowContextStore.setContext({
      promotionId,
      deviceId,
      returnUrl: effectiveReturnUrl,
      autoGenerateCoupon: autoGenerateCoupon || storeState.autoGenerateCoupon,
      originRoute
    });
    return true;
  }

  if (flowContextOptional) {
    flowContextStore.setContext({
      promotionId: promotionId ?? null,
      deviceId: deviceId ?? null,
      returnUrl: effectiveReturnUrl,
      autoGenerateCoupon: autoGenerateCoupon || storeState.autoGenerateCoupon,
      originRoute
    });
    return true;
  }

  return router.createUrlTree(['/flow-error'], {
    queryParams: {
      reason: 'promotion-device',
      returnUrl: state.url
    }
  });
};
